import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from '../../Components/Mailbox/mailboxcontent2'

export const PrivateRoutes = ({ children }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  return isAuthenticated || localStorage.getItem('auth_token') ? (
    children
  ) : (
    <Login  />
  );
};

